module.exports = __webpack_public_path__ + "img/6_10_bg.d1dcf691.png";